var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07715 8C6.97715 8 6.03548 7.60833 5.25215 6.825C4.46882 6.04167 4.07715 5.1 4.07715 4C4.07715 2.9 4.46882 1.95833 5.25215 1.175C6.03548 0.391667 6.97715 0 8.07715 0C9.17715 0 10.1188 0.391667 10.9021 1.175C11.6855 1.95833 12.0771 2.9 12.0771 4C12.0771 5.1 11.6855 6.04167 10.9021 6.825C10.1188 7.60833 9.17715 8 8.07715 8ZM0.0771484 16V13.2C0.0771484 12.6333 0.223149 12.1123 0.515149 11.637C0.806482 11.1623 1.19381 10.8 1.67715 10.55C2.71048 10.0333 3.76048 9.64567 4.82715 9.387C5.89382 9.129 6.97715 9 8.07715 9C9.17715 9 10.2605 9.129 11.3271 9.387C12.3938 9.64567 13.4438 10.0333 14.4771 10.55C14.9605 10.8 15.3478 11.1623 15.6391 11.637C15.9311 12.1123 16.0771 12.6333 16.0771 13.2V16H0.0771484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c01c4b1ea2deedb2486a1976e53660de.svg";
export { ForwardRef as ReactComponent };